import { AnyAction } from 'redux'
import requestStatuses from '@cinch/oxd-utils/request-status/src'
import { REQUEST_PAYMENT_INTENT, RECEIVE_PAYMENT_INTENT, ERROR_PAYMENT_INTENT } from './types'

export interface InitialState {
  paymentIntentId: string
  paymentIntentIdStatus: string
  error?: string
}

export const initialState: InitialState = {
  paymentIntentId: '',
  paymentIntentIdStatus: requestStatuses.INITIAL,
}

export default function paymentsReducer(state = initialState, action: AnyAction) {
  switch (action.type) {
    case REQUEST_PAYMENT_INTENT:
      return {
        ...state,
        paymentIntentIdStatus: requestStatuses.PENDING,
      }
    case RECEIVE_PAYMENT_INTENT:
      return {
        ...state,
        paymentIntentId: action.payload.clientSecret,
        amount: action.payload.amount,
        paymentIntentIdStatus: requestStatuses.SUCCESS,
      }
    case ERROR_PAYMENT_INTENT:
      return {
        ...state,
        error: action.payload,
        paymentIntentIdStatus: requestStatuses.ERROR,
      }
    default:
      return state
  }
}
